import {Component, ViewChild} from "@angular/core";
import {Field} from "../field";


@Component({
	selector: "tig-checkbox", template: `
    <div class="form-group"
		[class.has-error]="OBJ_checkbox?.invalid">
        <label class="col-lg-3 control-label" for="{{OBJ_field_config.name}}">{{getLabelName()|translate}}
            <i *ngIf="getHint()" class="fa fa-info-circle"
               tooltip="{{getHint()|translate}}"
               placement="top"
               triggers="click"
               containerClass="tig-tooltip"
               delay="50"></i>
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
        </label>
        <div class="col-lg-8">
            <div tigCheck>
                <input
                    #OBJ_checkbox="ngModel"
                    [required]="isRequired()"
                    type="checkbox"
                    class="form-control"
                    id="{{OBJ_field_config.name}}"
                    name="{{OBJ_field_config.name}}"
                    [(ngModel)]="OBJ_data[OBJ_field_config.name]"
                    [disabled]="OBJ_field_config?.readonly" />
                <span class="help-block m-b-none" *ngIf="OBJ_checkbox?.invalid">
                    {{'oError.sRequired'|translate}}
                </span>
            </div>
        </div>
    </div>
  `
})
export class CheckboxComponent extends Field
{} // end class CheckboxComponent
